import { useContext } from 'react';
import { ContextProvider, Context_StatusBox, Context_Compliance_Scores, Context_Explore_Laws, Context_Navigation} from '../../Data/ContextProvider';
import SelectorDropdown from '../../Global_Components/SelectorComp';
//import SubWRec_Explan_Alert from '../Analysis/SubWRec_Explanation';
import Select from 'react-select';
import { Redirect, Route, Switch } from "react-dom";
import React, { Component } from "react";

//import './Select_Business_Model.module.css';

export default function Select_Law() {

    const [Explore_Laws_GVars, Update_Explore_Laws_GVars] = useContext(Context_Explore_Laws);
    const [Navigation_GVars, Update_Navigation_GVars] = useContext(Context_Navigation);
    const [StatusBox_Data_GVars, Update_StatusBox_Data_GVars] = useContext(Context_Compliance_Scores);

    var selectedOption = null;

    

    return (
        <>

            {((Explore_Laws_GVars.ExploreLaws_Selected == null) || (Explore_Laws_GVars.ExploreLaws_Selected[0] == 'Reset')) ?
                <div className='selector_Frame1_CSS'>
                    < div className="unselected1_Item"> Please make a selection to explore legal topics: </div>
                    <div className="selector1_CSS">
                        <Select
                            value={selectedOption}
                            onChange={(selectedOption) => { if (selectedOption != null) { handleSelectDatafromDropdown(selectedOption)} }}
                            options={Explore_Laws_GVars.Laws_Array}
                            placeholder="Select, or type to search..."

                        />     
                    </div>
                </div>

                : <div className='selector_Frame1_CSS'>
                    < div className="selectedItem_Header_L1">You have selected:</div>
                    
                    {(Explore_Laws_GVars.ExploreLaws_Selected[1].length < 40) ?
                        < div className="selectedItem_Header_L2_Short">{Explore_Laws_GVars.ExploreLaws_Selected[1]}</div>
                        : < div className="selectedItem_Header_L2_Long">{Explore_Laws_GVars.ExploreLaws_Selected[1]}</div>
                    }

                    <div className="selector1_CSS">

                        <Select
                            value={selectedOption}
                            onChange={(selectedOption) => { if (selectedOption != null) { handleSelectDatafromDropdown(selectedOption) } }}
                            options={Explore_Laws_GVars.Laws_Array}
                            placeholder="Select another legal topic..."
                        />
                    </div>
                
                </div>          
            }
            {Explore_Laws_GVars.ExploreLaws_Selected != null ? <>
                <Change_Page_based_on_Selection /></> : <></>}
            </>
            
    );

function Change_Page_based_on_Selection() {

    if (Explore_Laws_GVars.ExploreLaws_Selected != null && Explore_Laws_GVars.ExploreLaws_Selected[0] == "Regulation_E" && Navigation_GVars.Law_Regulation_E_Page == false) {

        Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, Law_Regulation_E_Page: true }));

        var locVar = "You are learning about Regulation E, related Federal Laws, and parallel State Laws";
        Update_StatusBox_Data_GVars(StatusBox_Data_GVars => ({ ...StatusBox_Data_GVars, Checking_Comp_With: locVar }));
    }


    if (Explore_Laws_GVars.ExploreLaws_Selected != null && Explore_Laws_GVars.ExploreLaws_Selected[0] == "Remittance_Transferrs_Reg_E" && Navigation_GVars.Law_Remittance_Transfers_Regulation_E_Page == false) {

        Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, Law_Remittance_Transfers_Regulation_E_Page: true }));

        var locVar = "You are learning about Remittance Transfers under Regulation E, and related Federal Laws";
        Update_StatusBox_Data_GVars(StatusBox_Data_GVars => ({ ...StatusBox_Data_GVars, Checking_Comp_With: locVar }));
    }


    return (<></>)
}

    


    function ResetMenuOptions() {
    
        Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, Law_Regulation_E_Page: false })); 

        Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, Law_Remittance_Transfers_Regulation_E_Page: false })); 

        Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, Law_Remittance_Transfers_Regulation_E_Page: false })); 

        Update_Navigation_GVars(Navigation_GVars => ({ ...Navigation_GVars, Law_MSB_Laws_Page: false })); 

        

        return (
            <></>
        )
    }


    function handleSelectDatafromDropdown(selectedOption) {
        //const [Business_Models_GVars, Update_Business_Models_GVars] = useContext(Context_Business_Models);
        //Update_Business_Models_GVars(Business_Models_GVars => ({ ...Business_Models_GVars, BusinessModel_Selected: [selectedItem.value, selectedItem.text] }));

        Update_Explore_Laws_GVars(Explore_Laws_GVars => ({ ...Explore_Laws_GVars, ExploreLaws_Selected: [selectedOption.value, selectedOption.text] }))

        if (Explore_Laws_GVars.ExploreLaws_Selected != null && selectedOption.value != Explore_Laws_GVars.ExploreLaws_Selected[0]) {
            ResetMenuOptions()
        }


        return (
            <></>
        )
    };

}

